const eventReducer = (data = [], action) => {	
  if (action.type === 'FETCH_UPCOMING_EVENTS_LIST') {
    return action.payload;
  }
  return data;
};

export default eventReducer